import { ThemeProvider } from '@/providers/theme-provider';
import { PWAProvider } from '@/providers/pwa-provider';
import { AppRouter } from '@/routes';
import { Toaster } from '@/components/ui/toaster';
import { Toaster as SonnerToaster } from 'sonner';
import { ErrorBoundary } from '@/components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <PWAProvider>
          <AppRouter />
          <Toaster />
          <SonnerToaster position="top-right" richColors closeButton duration={4000} />
        </PWAProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
